import { MutationTree } from 'vuex';
import { SET_STATES } from './mutation-types';
import State from './state';
import { ICity } from '../../../models/interfaces/iCity'

const mutations: MutationTree<State> = {

  [SET_STATES](state: State, data: string[]): void {
    //debugger;
    state.all = data;
  }
};

export default mutations;



// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/states/mutations.ts